<template>
  <div class="e-asset-header">
    <b-row>
      <div class="col-4 asset-info">
        <img class="logo" :src="asset.logoPath">
        <div class="info">
          <h2>{{ asset.name }}</h2>
          <small>({{ asset.symbol }})</small>
        </div>
      </div>
      <transition mode="out-in" name="fade">
        <b-col v-if="isHintVisible && hint" key="hint">
          <e-hint :title="hint.title || ''">{{ hint.text || '' }}</e-hint>
          <e-button color="gray" type="outlined" size="smaller" class="px-3 mt-2" @click="hideHint">{{ hint.buttonText }}</e-button>
        </b-col>
        <b-col v-else cols="7" offset="1" key="asset-data">
          <div class="asset-meta" v-if="meta">
            <div class="item" v-for="(item, k) in meta" :key="k">
              <div class="value">{{ item.value }}</div>
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </b-col>
      </transition>
    </b-row>
  </div>
</template>

<script>
	import {convertRateToEmixtier} from "@utils/assets";
  import Cookies from 'cookies-js';

  export default {
		name: "em-modal-asset-header",
    props: {
		  asset: Object,
      hint: Object,
      meta: Array,
      type: String,
    },
    data() {
		  return {
        isHintVisible: false,
      }
    },
    methods: {
      hideHint() {
        this.isHintVisible = false;
        Cookies.set(`hintDisabled_${this.type}`, true);
      }
    },
    computed: {
      assetEmixtier() {
        return convertRateToEmixtier(this.asset.rate);
      }
    },
    created() {
      let hintDisabled = Cookies.get(`hintDisabled_${this.type}`);
      this.isHintVisible = !hintDisabled;
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/header.vue